<template>
    <!-- 전체 콘텐츠 영역 -->
    <div class="main-contents">
        <div class="mem_container resume">
            <div class="mem_info_contents">
                <div class="mem_contents_header">
                    <div class="title-txt">내 프로필 관리<br/><span>이력서 및 소속사 관리 / NCS 직무 자가평가</span></div>
                </div>
                
                <div class="tab-type1">
                    <ul class="tab">
                        <li @click="pageMove('res')"><a>내 이력서 관리</a></li>
                        <li class="on">
                            <!-- <div v-if="asgRegYn == 'N'" class="alarm show"><img src="/images/tab_alarm.png" alt="미등록항목알람"><p>미평가 항목이 있습니다.</p></div> -->
                            <a>내 소속사 관리</a>                            
                        </li>
                        <li @click="pageMove('ncs')"><a>내 NCS 직무 자가평가</a></li>
                    </ul>
                </div>

                <div class="contents-body tab flex">

                    <!-- 소속사 승인 요청 -->
                    <div class="corpMng-box company">
                        <div class="tit">소속사</div>

                        <div class="corpInfo-box">
    
                            <div class="approv">
                                <!-- <img :src=" mberInfo.asgApprStatus == '01' ? '/images/tec/prf/approv_img2.png' :'/images/tec/prf/approv_img1.png'"> -->
                                <div class="approv-tit">소속사</div>
                                <span v-if="mberInfo.asgApprStatus == '02'">소속사 승인 처리중 입니다 <img src="/images/tec/prf/progress.png"></span>
                                <span v-if="mberInfo.asgApprStatus == '04'">소속사 탈퇴 처리중 입니다 <img src="/images/tec/prf/progress.png"></span>

                                <div v-if="mberInfo.asgApprStatus == '01' || mberInfo.asgApprStatus == '03'" class="approv-name">
                                    <div>
                                        <span v-if="mberInfo.asgApprStatus == '01'" style="color: #a7a9ac;">소속사가 없습니다.</span>
                                        <span v-if="mberInfo.asgApprStatus == '03'">{{ mberInfo.corpNm }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="Area">
                                <div class="Item">
                                    <table class="tb">
                                        <tbody>
                                            <tr>
                                                <th>
                                                    <label><nbsp/>소속사 구분</label>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input v-if="mberInfo.asgApprStatus == '01'" type="radio" id="rd06" v-model="asgInfo.mberCorpDiv" value="2"  @change="mberCorpDivCng('Y')">
                                                    <input v-else-if="mberInfo.asgApprStatus == '03'" type="radio" id="rd06" v-model="asgInfo.mberCorpDiv" value="2" onclick ="alert('소속사 탈퇴 후 변경이 가능합니다.'); return false;">
                                                    <input v-else type="radio" id="rd06" v-model="asgInfo.mberCorpDiv" value="2" onclick ="alert('승인 처리중 일때는 변경이 불가능 합니다.'); return false;">
                                                    <label for="rd06">
                                                        <span class="rd"></span>
                                                        소속사 있음
                                                        <AutoComplete v-if="disabledChkBox == true" disabled="true" class="ml-3" title="소속사를 선택하세요"></AutoComplete>
                                                        <AutoComplete v-else class="ml-3" type="text" v-model="asgInfo.corpNm" :list="corpList" listText="corpNm" @autoComplete="setCorpInfo" title="소속사를 선택하세요" :rules="{'required':true}" :disabled="mberInfo.asgApprStatus != '01'">
                                                            <template v-slot:autoComplete="autoComplete">{{autoComplete.item.corpNm}} / {{autoComplete.item.bizRegNo}}</template>
                                                        </AutoComplete>
                                                    </label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input v-if="mberInfo.asgApprStatus == '01'" type="radio" id="rd07" v-model="asgInfo.mberCorpDiv" value="3" @change="mberCorpDivCng('N')">
                                                    <input v-else-if="mberInfo.asgApprStatus == '03'" type="radio" id="rd07" v-model="asgInfo.mberCorpDiv" value="3" onclick ="alert('소속사 탈퇴 후 변경이 가능합니다.'); return false;">
                                                    <input v-else type="radio" id="rd07" v-model="asgInfo.mberCorpDiv" value="3" onclick ="alert('승인 처리중 일때는 변경이 불가능 합니다.'); return false;">
                                                    <label for="rd07" class="rd">
                                                        <span class="rd"></span>
                                                        소속사 없음
                                                    </label>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th class="pt-11">
                                                    <label for="txt08"><nbsp/>직원구분</label>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <SelectComp v-if="mberInfo.asgApprStatus == '01'" type="radio" cdId="PRO102" v-model="asgInfo.empDivCd" defValue="01" :disabled="asgInfo.mberCorpDiv == '3'"/>
                                                    <SelectComp v-else-if="mberInfo.asgApprStatus == '03'" type="radio" cdId="PRO102" v-model="asgInfo.empDivCd" defValue="01" onclick ="alert('소속사 탈퇴 후 변경이 가능합니다.'); return false;"/>
                                                    <SelectComp v-else type="radio" cdId="PRO102" v-model="asgInfo.empDivCd" defValue="01" onclick ="alert('승인 처리중 일때는 변경이 불가능 합니다.'); return false;"/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>

                        <!-- 등록/탈퇴 버튼 -->
                        <div class="select_btn mt-7">
                            <!-- <div class="btn_01" @click="btnCancel()">취소</div> -->
                            <div v-if="mberInfo.asgApprStatus == '03'" class="btn_02" style="background-color: #A7A9AC;" @click="btnSubmit('asgWithdrawal')">소속사 탈퇴</div>
                            <div v-else-if="mberInfo.asgApprStatus == '02' || mberInfo.asgApprStatus == '04'|| grayBtnFlag == true" class="btn_02 grayBtn">등록하기</div>
                            <div v-else-if="mberInfo.asgApprStatus == '01'" class="btn_03" style="background-color: #0165FF;" @click="btnSubmit('asgReg')">등록하기</div>
                            
                        </div>

                        <div class="noti-txt">
                            <p>&#8251; 소속사 승인 관련 유의사항</p>
                            <div class="pl-2" style="line-height: 22px;">
                                1. 소속사가 있는 경우, 소속사 승인을 받아야 합니다. <br />
                                    <nbsp n="4"/><span style="color: red;">* 소속사가 있는 경우, 승인을 받지 않으면 프로젝트에 지원할 수 없음</span><br />
                                2. 소속사 승인은 해당 소속사의 상황에 따라 처리기간이 달라질 수 있음을 알려드립니다. <br />
                                3. '소속사 없음'을 선택하실 경우, 직원구분은 '프리랜서'로 자동설정 됩니다. <br />
                                &#9733; 소속사 변경을 하실 경우 '소속탈퇴'를 하신 후 변경하실 소속사 승인을 받으셔야 합니다.
                            </div> 
                        </div>
                        
                    </div>
                    
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import nbsp from '../../../components/base/nbsp.vue';

export default {
  components: { nbsp },

    data() {
        return {
            isMounted: false,
            
            chkGrayBtn : false,
            grayBtnFlag : false,    // 등록버튼 비활성화
            disabledChkBox : false, // 소속사 선택

            mberInfo: {
                asgApprStatus : '', // 01 : 소속사신청 가능, 02 : 승인대기(입사), 03: 승인대기(퇴사), 04: 퇴사신청 가능

                corpNm : '',
                empDivCd : '',
                aftAsgNm : '',
                aftEmpDivCd : '',
            },

            asgInfo: {
                mberCorpDiv: '2', // 2: 소속사 있음, 3: 소속사 없음
                corpSeq : '',
                corpNm : '',
                empDivCd : '',

            },

            corpList : [],
        };
    },
    mounted(){
        this.isMounted = true;
        this.tecAsgInfo();
        this.corpSearch('20');
    },
    methods: {
        tecAsgInfo(){
            this.$.httpPost('/api/mem/prf/getTecAsgInfo', {mberSeq : this.$store.state.userInfo.mberSeq})
                .then(res => {
                    this.mberInfo = res.data.tecAsgInfo;

                    /* 소속사 */
                    if(this.mberInfo.asgApprStatus == '01' && this.mberInfo.empDivCd == '02'){ // 소속없음 && 프리랜서
                        this.asgInfo.mberCorpDiv = '3';
                        this.asgInfo.empDivCd = '02';

                        this.chkGrayBtn = true;
                        this.grayBtnFlag = true;
                        this.disabledChkBox = true;

                    }else if(this.mberInfo.asgApprStatus != '01'){ // 소속있음 + (승인대기 또는 승인완료) 
                        this.asgInfo.mberCorpDiv = '2';
                        this.asgInfo.corpNm = this.mberInfo.aftAsgNm;
                        this.asgInfo.corpSeq = this.mberInfo.aftCorpSeq;
                        this.asgInfo.empDivCd = this.mberInfo.aftEmpDivCd;

                        if(this.mberInfo.asgApprStatus == '04') this.asgInfo.empDivCd = this.mberInfo.empDivCd; // 승인대기(퇴사)
                    }

                }).catch(err => {
                    alert(err.response.data.error_description);
            });
        },

        corpSearch(div) {
            var param = {
                corpDivCd : div,
            }
			this.$.httpPost('/api/mem/prf/getCorpList', param)
                .then(res => {
                    this.corpList = res.data.corpList;
                }).catch(err => {
                    alert(err.response.data.error_description);
            });
		},

        setCorpInfo(corpInfo) {
			if(corpInfo) {
				this.asgInfo.corpSeq = corpInfo.corpSeq;
				this.asgInfo.corpNm = corpInfo.corpNm;
			}else {
				this.asgInfo.corpSeq = '';
				this.asgInfo.corpNm = '';
			}
		},


        // 소속사 구분 변경
		mberCorpDivCng(div) {
            if(div == 'N'){
                this.asgInfo.corpSeq = '';
                this.asgInfo.corpNm = '';
                this.asgInfo.bizRegNo = '';
                this.asgInfo.empDivCd = '02';

                this.disabledChkBox = true;
            }else{
                this.disabledChkBox = false;
            }

            if(this.chkGrayBtn == true){
                if(div == 'Y') this.grayBtnFlag = false;  
                else this.grayBtnFlag = true;
            }
		},

        btnSubmit(div){
            var dataChk = true;
            var param = {
                mberSeq : this.$store.state.userInfo.mberSeq,
            }

            if(div == 'asgReg'){
                if(this.asgInfo.mberCorpDiv == '2' && (this.asgInfo.corpSeq == null || this.asgInfo.corpSeq == '')) {
                    dataChk = false;
                    alert("소속사를 선택해주세요.");
                }else{
                    param.classDivCd = '02';
                    param.corpSeq = this.asgInfo.corpSeq;
                    param.corpNm = this.asgInfo.corpNm;
                    param.empDivCd = this.asgInfo.empDivCd;
                }

            }else if(div == 'asgWithdrawal'){
                param.classDivCd = '04';
                param.corpSeq = this.mberInfo.corpSeq;
                param.corpNm = this.mberInfo.corpNm;
                param.empDivCd = this.mberInfo.empDivCd;
            }

            if(dataChk == true) { this.$.popup('/tec/prf/PRF104P01', param); }
            
          
        },
       
        btnCancel(){
            this.$router.go(-1);
        },

        // 페이지 이동
		pageMove(div) {
            if(div == 'res') {
                this.$router.push({name: 'PRF101M01'})
            } else if(div == 'ncs') { 
                this.$router.push({name: 'PRF102M02'});
            } else {
				this.$router.go(-1);
			}    
		},
    },
};
</script>